<template>
  <div ref="watermark" class="cont productCont">
    <el-breadcrumb separator="/" style="margin-bottom:21px">
      <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 12px;color: #999999 ">首页</el-breadcrumb-item>
      <el-breadcrumb-item style="font-size: 12px;color: #666666;">
        <div v-if="moduleUser.goods_visible == '1' "> {{ goods.goodsName }} </div>
        <div v-else-if="moduleUser.goods_visible == '0' "> {{ goods.goodsErp.specification ? goods.goodsErp.specification : ''}} </div>

      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="info" style="display:flex;align-items:center;padding-bottom:37px">
      <div style="width: 551px; height: 366px">
        <el-image
          style="width: 551px; height: 366px"
          :src=' this.common.publicUrl + goods.apiGoodsSpec.goodsPic '
          fit="contain"></el-image>
      </div>
      <div style="flex:1;margin-left:20px">

        <div style="margin-bottom:13px;font-size: 18px;font-weight: 700;color: #666666;float: left" v-if="moduleUser.goods_visible == '1' ">  {{ goods.goodsName }} </div>
        <div style="margin-bottom:13px;font-size: 18px;font-weight: 700;color: #666666;float: left" v-if="moduleUser.goods_visible == '0' ">  {{ goods.goodsErp.specification ? goods.goodsErp.specification : ''}} </div>

        <div style="text-align:right;flex:1" >
          <span style="margin-right:10px;font-size: 14px;color: #333333;">价格开关</span>
          <el-switch  v-model="priceShow"  @change="togglePriceShow">  </el-switch>
        </div>
        <!-- <div style="margin-bottom:35px;color: #999999">  适配雷克萨斯RX300 </div> -->

        <div style="background-color:#f9f9f9;padding:40px;margin-top:24px;margin-bottom:24px" class="clear">

          <div style="float:left;text-align:center;line-height:41px">
            <div style="font-size: 20px;font-weight: 700;color: #666666;margin-bottom:10px;height:40px;line-height:40px">¥ {{ goods.apiGoodsSpec.goodsPrice }} </div>
            <div style="font-size: 12px;color: #999999 ">零售价</div>
          </div>

          <div style="float:left;text-align:center;margin-left:60px;line-height:41px" v-if="priceShow&&goods.promotionStatus ==1" >
            <div style="font-size: 28px;font-weight: 700;color: #F04844;margin-bottom:10px;height:40px;line-height:40px;text-decoration: line-through;">¥{{ goods.apiGoodsSpec.discountPrice  }}</div>
            <div style="font-size: 14px;color: #F04844;text-decoration: line-through;">拿货价</div>
          </div>
          <div style="float:left;text-align:center;margin-left:60px;line-height:41px" v-if="priceShow&&goods.promotionStatus ==1"  >
            <div style="font-size: 28px;font-weight: 700;color: #F04844;margin-bottom:10px;height:40px;line-height:40px">¥{{ goods.promotionPrice  }}</div>
            <div style="font-size: 14px;color: #F04844">活动价</div>
          </div>

          <div style="float:left;text-align:center;margin-left:60px;line-height:41px" v-if="priceShow&&goods.promotionStatus !=1" >
            <div style="font-size: 28px;font-weight: 700;color: #F04844;margin-bottom:10px;height:40px;line-height:40px">¥{{ goods.apiGoodsSpec.discountPrice  }}</div>
            <div style="font-size: 14px;color: #F04844">拿货价</div>
          </div>
        </div>

        <div style="padding:20px;display:flex;align-items:center">
          <span style="font-size: 14px;color: #666666;margin-right:22px">数量</span>
          <el-image
            @click="addQuantity('reduce')"
            style="width: 53px; height: 31px;cursor : pointer"
            :src=' this.common.publicUrl + "/profile/avatar/-.png" '
            fit="contain"
          ></el-image>
          <div style="margin: 0 12px;font-size: 30px;color: #333333;min-width:40px;text-align:center"> {{ goods.quantity }} </div>
          <el-image
            @click="addQuantity('add')"
            style="width: 53px; height: 31px;cursor : pointer"
            :src=' this.common.publicUrl + "/profile/avatar/+.png" '
            fit="contain"
          ></el-image>

          <div v-if=' moduleUser.inventory_visible == "0" '>
            <el-image
              style="width: 115px; height: 31px;margin-left:50px"
              :src=' this.common.publicUrl + "/profile/avatar/现货充足.png" '
              fit="contain"
              v-if=' goods.amount > moduleUser.goods_num '
            ></el-image>
            <el-image
              style="width: 115px; height: 31px;margin-left:50px"
              :src=' this.common.publicUrl + "/profile/avatar/少量现货.png" '
              fit="contain"
              v-else-if=' goods.amount <= moduleUser.goods_num  && goods.amount > 0 '
            ></el-image>
            <el-image
              style="width: 115px; height: 31px;margin-left:50px"
              :src=' this.common.publicUrl + "/profile/avatar/可以预定.png" '
              fit="contain"
              v-else-if=' goods.amount == 0  '
            ></el-image>
          </div>
          <!-- <div v-else-if='{{ inventory_visible == "1" }}'></div> -->
        </div>

        <div style="margin-top:20px;display:flex">
          <div class="background_style btn"
            style='margin-right:25px;margin-left:25px;width:166px;height:36px;cursor : pointer'
            :style="{backgroundImage: 'url(' + btn_black + ')' }"
            @click="addCartItem"
          >

          </div>

          <div
            class="background_style btn"
            style='margin-right:25px;width:166px;height:36px;cursor : pointer'
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            @click="gotoSettle"
          >
          </div>
        </div>

      </div>
    </div>

    <div style="border: 1px solid rgb(228, 228, 228);margin-bottom:16px">
      <div style="border-bottom: 1px solid rgb(228, 228, 228);height: 50px;line-height:50px;font-size: 16px;color: #999999;text-indent:20px">
        同类商品推荐
      </div>
      <div style="min-height:296px;padding:22px 0 ; box-sizing:border-box;overflow-x: scroll;overflow-y: hidden;white-space: nowrap;">
        <div style="height:342px;width: 230px;;margin: 0  30px  ;border: 1px solid rgb(242, 242, 242);display:inline-block;cursor : pointer"
          v-for=" ( item , idx ) in goods.recommendList " :key='idx'
          @click="gotoDetail(item)"
        >
          <div style="text-align:center">
            <el-image
              style="width: 200px; height: 200px;margin-top:16px;margin-bottom:18px"
              class="product_image"
              :src=' publicUrl + item.goodsPic '
              fit="contain"
            ></el-image>
          </div>
          <div style="font-size: 12px;color: #333333;margin-bottom:7px;text-align:center">{{ item.goodsName }}</div>
          <div style="font-size: 14px;color: #F04844;display:flex;justify-content:space-around;margin-top:20px">

            <div style="color: #7F7F7F;">
              <div>零售价</div>
              <div> ¥ {{ item.apiGoodsSpec.goodsPrice }}</div>
            </div>

            <div style="color: #E60012;" v-if="priceShow&&item.promotionStatus ==1">
              <div style="text-decoration: line-through;">拿货价</div>
              <div style="text-decoration: line-through;"> ¥ {{item.apiGoodsSpec.discountPrice }}</div>
            </div>
            <div style="color: #E60012;" v-if="priceShow&&item.promotionStatus ==1">
              <div>活动价</div>
              <div> ¥ {{item.promotionPrice }}</div>
            </div>

            <div style="color: #E60012;" v-if="priceShow&&item.promotionStatus !=1">
              <div>拿货价</div>
              <div> ¥ {{item.apiGoodsSpec.discountPrice }}</div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div v-if="images.length>0" class="product-container">
      <div style="margin-left:10px;margin-bomtton:10px;height: 50px;line-height:50px;font-size: 16px;color: #999999;text-indent:20px;display: flex">
        参数
        <div  @click="itemDetail" class="red-slant" style="cursor : pointer;text-align: center;"
        >
          <div style="transform: skewX(30deg);"> 查看更多适用车型 >></div>
        </div>
      </div>
      <div style=" display: flex;">
        <!-- 左侧图片区域 -->
        <div class="product-img-wrapper" >
          <div  v-for="(item, index) in images" :key="index">
            <el-image :src="item"
                 alt="产品图片"
                 class="product-img"  :preview-src-list="images"
            ></el-image>
          </div>
        </div>

        <!-- 右侧数据区域 -->
        <div class="product-data">
          <div class="data-grid">
            <div class="data-item" v-for="(item, index) in properties" :key="index">
              <span class="data-label">{{ item.name }}:</span>
              <span class="data-value">{{ item.value }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div>
      <div style="background-color:#f9f9f9;color:#a9a9a9;line-height:40px;padding:0 20px;box-sizing:border-box">商品详情</div>
      <div v-html=' goods.content' style="width:600px;margin:0 auto"></div>
    </div>

    <el-backtop>
      <div>
          <el-image
            style="width: 50px; height: 50px"
            :src=" publicUrl + '/profile/avatar/u2397.png' "
            fit="contain">
          </el-image>
      </div>
    </el-backtop>



    <el-dialog title="" :visible.sync="showFlag" width="1000px" center  :show-close='false'
                 >
      <div>
        <table class="car-table">
          <!-- 表头 -->
          <thead>
          <tr>
            <th>品牌</th>
            <th>车型</th>
            <th>排量</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(brandItem, brandIndex) in itemFitAuto" >
            <!-- 遍历每个品牌下的车型 -->
            <tr v-for="(modelItem, modelIndex) in brandItem.autos"  :key="`${brandIndex}-${modelIndex}`">
              <!-- 品牌单元格：仅在第一个车型行显示，并设置 rowspan -->
              <td class="brand-cell"  v-if="modelIndex === 0"   :rowspan="brandItem.autos.length">
                {{ brandItem.brandName }}
              </td>
              <!-- 车型和排量单元格 -->
              <td class="model-cell">{{ modelItem.modelName }}({{modelItem.yearText}})</td>
              <td class="displacement-cell">{{ modelItem.subName }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div style="display:flex;justify-content:center">
        <div class="background_style btn"  :style="{backgroundImage: 'url(' + btn_red2 + ')' }"
             style="cursor : pointer;margin-top:20px"  @click="showFlag=false;" >
          关闭
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<style lang="stylus" scoped>
  /* 表格样式 */
  .car-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }

  .car-table th,
  .car-table td {
    padding: 12px 15px;
    text-align: center;
    border: 1px solid #ddd;
    word-wrap: break-word; /* 内容过长自动换行 */
  }

  /* 表头样式 */
  .car-table th {
    background-color: #f2f2f2;
    font-weight: bold;
    color: #555;
  }

  /* 品牌列样式 */
  .brand-cell {
    background-color: #f9f9f9;
    font-weight: bold;
    color: #333;
    width: 200px;
  }

  /* 车型列样式 */
  .model-cell {
    width: 600px;
  }

  /* 排量列样式 */
  .displacement-cell {
    width: 200px;
  }

  /* 交替行样式（可选） */
  .car-table tr:nth-child(even) td:not(.brand-cell) {
    background-color: #fafafa;
  }
.red-slant {
  width: 200px;
  line-height: 40px;
  height: 40px;
  color: #fff;
  background-color: red;
  transform: skewX(-30deg);
  transform-origin: 0 0;
  text-align: center;
  margin-left: 60px;
  font-size: 12px;
}

.cont {
  width: 1200px;
  color: #000;
  margin: 0 auto;
  box-sizing: border-box;
  padding : 20px 0
}

/* 基础样式 */
.product-container {

  width: 1200px;
  margin-bottom 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 左侧图片样式 */
.product-img-wrapper {
  padding: 10px;
  width: 200px; /* 保持100rpx宽度（rpx在Vue中可直接使用，1rpx≈0.5px） */
  position: relative;
  cursor: pointer;
  margin-right: 20px;
}

.product-img {
  width: 200px;
  height: auto;
  transition: transform 0.3s ease;
}

/* 悬停效果 */
.product-img-wrapper:hover .product-img {
  transform: scale(1.05);
}

.preview-tip {
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #666;
  background-color: #f5f5f5;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

/* 右侧数据样式 */
.product-data {
  flex: 1; /* 占满剩余宽度 */
}

.product-title {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

/* 网格布局 - 每行最多3个 */
.data-grid {
  display: flex;
  flex-wrap: wrap; /* 自动换行 */
  gap: 12px; /* 间距 */
}

.data-item {
  width: calc(30% - 8px); /* 3列布局，减去间距 */
  padding: 10px 12px;
  background-color: #f9f9f9;
  border-radius: 6px;
  transition: all 0.2s ease;
}

/* 响应式调整：小屏幕时每行2个 */
@media (max-width: 768px) {
  .data-item {
    width: calc(30% - 6px);
  }
}

/* 数据项悬停效果 */
.data-item:hover {
  background-color: #f0f7ff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.data-label {
  display: inline-block;
  width: 55%;
  color: #666;
  font-weight: 500;
}

.data-value {
  color: #333;
  font-weight: 600;
}
</style>

<script>

import {
  getGoodsReq ,
  addCartItemReq ,
} from "@/api/productDetail/productDetail";
import watermark from '@/utils/waterMark'
  export default {
  comments:watermark,
    data() {
      return {
        num: 1 ,
        publicUrl : this.common.publicUrl ,
        btn_red2 : this.common.publicUrl + '/profile/avatar/u146.png' ,
        btn_red : this.common.publicUrl + '/profile/avatar/u9211.png' ,
        btn_black : this.common.publicUrl + '/profile/avatar/u9201.png' ,
        u35 : this.common.publicUrl + '/profile/avatar/u35.png' ,
        goodsId : '' ,
        jancode : '' ,
        beforeParamValue :  '',
        afterParamValue : '',
        priceShow : true ,
        showFlag : false ,
        searchValue : '' ,
        searchType : null ,
        vin : null ,
        properties:[],
        itemFitAuto:[],
        images:[],
        goods : {
          apiGoodsSpec : {

          },
          goodsErp : {}
        } , //产品信息
        count : 0 , //购买数量
      };
    },
    mounted(){
      this.$nextTick(()=>{
        let  dealerName =window.localStorage.dealerName
        let  username =window.localStorage.username
        let text =dealerName+username.substring(username.length-4,username.length)
        watermark.set(text,this.$refs.watermark);
      })
    },
    methods: {
      handleChange(value) {
        // console.log(value);
      } ,
      //获取产品详情
      getGoods(){
        getGoodsReq({
          goodsId : this.goodsId ,
          jancode : this.jancode
        }).then( res => {
          if (res.data.status == 0) {
            res.data.goods.quantity = 1
            this.goods = res.data.goods
            this.count = res.data.count
            this.properties =res.data.properties==null?[]:res.data.properties
            this.itemFitAuto =res.data.itemFitAuto==null?[]:res.data.itemFitAuto
            this.images  =res.data.images==null?[]:res.data.images
          } else {
            this.$message.error(res.data.statusDesc);
          }
        })
      } ,
      //修改商品当前规格数量
      addQuantity(status){
        let curGoodsInfo = this.goods
        if( status == 'add' ){
          curGoodsInfo.quantity = curGoodsInfo.quantity - 0 + 1
        }else if ( status == 'reduce' ){
          if(curGoodsInfo.quantity  > 1){
            curGoodsInfo.quantity = curGoodsInfo.quantity - 1
          }
        }
        this.goods = curGoodsInfo
      },
      //加入购物车
      addCartItem(){
        let curGoodsInfo = this.goods
        addCartItemReq({
          goodsId : curGoodsInfo.goodsId ,
          goodsName : curGoodsInfo.goodsName ,
          jancode : curGoodsInfo.apiGoodsSpec.jancode ,
          goodsSpecId : curGoodsInfo.apiGoodsSpec.goodsSpecId ,
          quantity : curGoodsInfo.quantity ,
          goodsPic : curGoodsInfo.apiGoodsSpec.goodsPic ,
          subTitle : curGoodsInfo.subTitle? curGoodsInfo.subTitle : '' ,
          specSkuId : curGoodsInfo.apiGoodsSpec.specSkuId ,
          sukSpec  : curGoodsInfo.apiGoodsSpec.sukSpec ,
          searchValue : this.searchValue ? this.searchValue : ''  ,
          searchType : this.searchType ,
          vin : this.vin ? this.vin : '',
          beforeParamValue : this.beforeParamValue ? this.beforeParamValue : '',
          afterParamValue : this.afterParamValue ? this.afterParamValue : '',
          description : curGoodsInfo.description
        }).then(  res => {
          if (res.data.status == 0) {
            //触发购物车数量改变
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.$store.commit('cart_refresh_open');
          } else {
            this.$message.error(res.data.statusDesc);
          }
        } )
      },
      //前往结算
      gotoSettle(){
        let item = this.goods
        let apiTempOrder = []
        apiTempOrder.push({
          goodsId : item.goodsId ,
          jancode : item.apiGoodsSpec.jancode ,
          quantity : item.quantity ,
          searchValue : this.searchValue ? this.searchValue : '',
          vin : this.vin ? this.vin : '',
          beforeParamValue : this.beforeParamValue ? this.beforeParamValue : '',
          afterParamValue : this.afterParamValue ? this.afterParamValue : ''
        })

        if( apiTempOrder.length <= 0 ){
          this.$message('暂时不能购买');
          return
        }
        this.$store.commit('cart_refresh_open');
        apiTempOrder =  JSON.stringify( apiTempOrder )
        this.$router.push({
          path: '/splitOrder',
          query: {
            apiTempOrder : apiTempOrder ,
            isCartItem : 0 ,
          }
        })

      },
      //前往产品详情
      gotoDetail(goodItem){
        let goodsId = goodItem.goodsId
        let jancode = goodItem.apiGoodsSpec.jancode

        this.goodsId = goodsId
        this.jancode = jancode
        this.searchValue = this.$route.query.searchValue ? this.$route.query.searchValue  : ''
        this.vin = this.$route.query.vin ? this.$route.query.vin : ''
        this.searchType = this.$route.query.searchType
        this.getGoods()
        window.scrollTo(0 , 0)

      },
      togglePriceShow(){
        window.localStorage["priceShow"] =this.priceShow?"0":"1";
      },
      itemDetail(){
        this.showFlag= true;
      }
    },
    computed : {
      moduleUser() {
        return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
      }
    },
    created(){
      this.goodsId = this.$route.query.goodsId
      this.jancode = this.$route.query.jancode
      this.searchValue = this.$route.query.searchValue ? this.$route.query.searchValue  : ''
      this.vin = this.$route.query.vin ? this.$route.query.vin : ''
      this.searchType = this.$route.query.searchType
      this.afterParamValue = this.$route.query.afterParamValue
      this.beforeParamValue = this.$route.query.beforeParamValue
      this.getGoods()
      this.$nextTick(()=>{
        console.log(window.localStorage.priceShow==0?true:false)
        this.priceShow = window.localStorage.priceShow==0?true:false;
      })

    },

  };
</script>
